import React from 'react';

import { StyledPropertyStatus } from './StyledComponents';

function PropertyStatus(props) {
    const { code, message } = props;

    return (
        <StyledPropertyStatus
            className="SOHListingStatus"
            code={code}
        >
            {message}
        </StyledPropertyStatus>
    );
}

export default PropertyStatus;
